import {
  STAFF_CLOSE_HOUR_IN_SECONDS,
  STAFF_OPEN_HOUR_IN_SECONDS,
} from '../../configs/siteAndTrustAttributes';
import { getDaySlotsByHour } from '../../utils/appointmentUtil';
import { addMinutes, setHours, startOfDay } from '../../utils/dateUtil';
import { useSiteIntAttributes } from '../useAttribute';
import { useActiveSiteApptLength } from './useActiveSiteApptLength';

export type BookingSlot = {
  hour: number;
  minutes: number[];
  lastAppointmentEndTime: Date;
};

export const useSiteHourRange = () => {
  const [openHourInSeconds = 0, closeHourInSeconds = 0] = useSiteIntAttributes(
    STAFF_OPEN_HOUR_IN_SECONDS,
    STAFF_CLOSE_HOUR_IN_SECONDS,
  );
  const apptLength = useActiveSiteApptLength();

  const slots: BookingSlot[] = getDaySlotsByHour({
    openHourInSeconds,
    closeHourInSeconds,
    slotLengthInMinutes: apptLength,
  }).map((slot) => ({
    ...slot,
    lastAppointmentEndTime: addMinutes(
      setHours(startOfDay(new Date()), slot.hour),
      slot.minutes[0] + slot.minutes.length * apptLength,
    ),
  }));

  return {
    slots,
    appointmentLength: apptLength || 0,
  };
};
